import { getAccountBillingPlans } from '@gonfalon/openapi/operations/getAccountBillingPlans';
import { getAccountSubscription } from '@gonfalon/openapi/operations/getAccountSubscription';
import { getAccruedInvoices } from '@gonfalon/openapi/operations/getAccruedInvoices';
import { getBillingPlans } from '@gonfalon/openapi/operations/getBillingPlans';
import { getLimitPlans } from '@gonfalon/openapi/operations/getLimitPlans';
import { getPaymentCard } from '@gonfalon/openapi/operations/getPaymentCard';
import { getSubscription } from '@gonfalon/openapi/operations/getSubscription';
import { getSubscriptionUsage } from '@gonfalon/openapi/operations/getSubscriptionUsage';
import { getSubscriptionUsageStatus } from '@gonfalon/openapi/operations/getSubscriptionUsageStatus';
import { getTrialExtensionEligibility } from '@gonfalon/openapi/operations/getTrialExtensionEligibility';

import { createQueryOptions } from '../internal/createQueryOptions';

export const getAccountBillingPlansQuery = createQueryOptions(getAccountBillingPlans);
export const getAccruedInvoicesQuery = createQueryOptions(getAccruedInvoices);
export const getBillingPlansQuery = createQueryOptions(getBillingPlans);
export const getLimitPlansQuery = createQueryOptions(getLimitPlans);

export const getSubscriptionQuery = createQueryOptions(getSubscription);
export const getSubscriptionUsageQuery = createQueryOptions(getSubscriptionUsage);
export const getSubscriptionUsageStatusQuery = createQueryOptions(getSubscriptionUsageStatus);
export const getLegacySubscriptionQuery = createQueryOptions(getAccountSubscription);
export const getPaymentCardQuery = createQueryOptions(getPaymentCard);
export const getTrialExtensionEligibilityQuery = createQueryOptions(getTrialExtensionEligibility);
